import { render, staticRenderFns } from "./ProfileBase.vue?vue&type=template&id=959b613c&"
import script from "./ProfileBase.vue?vue&type=script&lang=js&"
export * from "./ProfileBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports